import { Command } from 'commands/Commands';

export class RemovePartnerFromBusiness extends Command {
  type: string = 'Partner.RemoveFromBusiness';
  constructor(payload: string, id: string = payload) {
    super(payload, id);
  }
  priority: number = 100;
}
